import { useEffect, useMemo, useState } from 'react';
import { apiService } from '../services/apiService';
import {
  appendMarketingUtm,
  buildProBookingProfileUrl,
} from '../utils/proBookingProfileUrl';

interface UseProBookingProfileUrlOptions {
  withMarketingUtm?: boolean;
}

export function useProBookingProfileUrl(
  proId: number | undefined,
  options: UseProBookingProfileUrlOptions = {}
) {
  const { withMarketingUtm = false } = options;
  const [slug, setSlug] = useState<string | null>(null);
  const [slugLoading, setSlugLoading] = useState(() => Boolean(proId));

  useEffect(() => {
    if (!proId) {
      setSlug(null);
      setSlugLoading(false);
      return;
    }
    let cancelled = false;
    setSlugLoading(true);
    void (async () => {
      try {
        const response = await apiService.get<{ slug?: string }>(`/get-pro/${proId}`);
        const nextSlug = response.data?.slug;
        if (!cancelled && nextSlug) {
          setSlug(String(nextSlug));
        }
      } catch {
        // slug optionnel — repli sur /profile/{proId}
      } finally {
        if (!cancelled) setSlugLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [proId]);

  const baseUrl = useMemo(() => {
    if (!proId) return '';
    return buildProBookingProfileUrl(proId, slug);
  }, [proId, slug]);

  const bookingUrl = useMemo(() => {
    if (!baseUrl) return '';
    return withMarketingUtm ? appendMarketingUtm(baseUrl) : baseUrl;
  }, [baseUrl, withMarketingUtm]);

  return { bookingUrl, baseUrl, slug, slugLoading };
}
